import { getTimelineCardWidth, getTimelineOffset } from '../roster-daily/components/card-width-utils';
import { useMemo } from 'react';
import { ROSTER_TAB } from '../components/roster-common-enums';
import { rosterConfig } from '../roster-config';

const { TIMELINE_CARD_HEIGHT, TIMELINE_ROW_HEIGHT } = rosterConfig;

export function useCardPosition(tab: ROSTER_TAB, startDateTime: Date, endDateTime: Date, rowIndex = 0) {
  return useMemo(() => {
    if (tab === ROSTER_TAB.WEEKLY) {
      return {
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
      };
    }

    return {
      width: getTimelineCardWidth(startDateTime, endDateTime),
      height: TIMELINE_CARD_HEIGHT,
      top: rowIndex === 0 ? 4 : rowIndex * TIMELINE_ROW_HEIGHT + 4,
      left: getTimelineOffset(startDateTime),
    };
  }, [tab, startDateTime, endDateTime, rowIndex]);
}
